/* import __COLOCATED_TEMPLATE__ from './numbered-step.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

export interface Args {
  stepNumber: number;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

const NumberedStep = templateOnlyComponent<Signature>();
export default NumberedStep;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions::NumberedStep': typeof NumberedStep;
    'reporting/automation/fin-ai-agent/analyze/task-suggestions/numbered-step': typeof NumberedStep;
  }
}
